import subCategoryStore from 'js/stores/store';
import subCategoryActions from 'js/actions/actions';
// Vendo imports

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
// import ToolbarGroup from 'material-ui/toolbar/toolbar-group';
// import ToolbarTitle from 'material-ui/toolbar/toolbar-title';
import React from 'react';

export class IconCard extends React.Component {
  updateFilteredPacks(url, index) {
    let symbology = subCategoryStore.getState().symbologyJson;

    let name = symbology.packs[index].name;

    let obj = { text: ' > ' + name, link: url + '?' + name };
    subCategoryActions.appendToBreadCrumbs(obj);
    subCategoryActions.updateFilteredPacks([symbology.packs[index]]);
    window.location.assign(window.location.pathname + url + '?' + name);
  }

  itemSelect(url, item) {
    let symbology = subCategoryStore.getState().symbologyJson;

    let obj = {
      text: ' > ' + item.keywords.join(' '),
      link: url + '?' + item.keywords.join('%20'),
    };

    subCategoryActions.appendToBreadCrumbs(obj);
    subCategoryActions.updateCurrentIcon(item);
    window.location.assign(
      window.location.pathname + url + '?' + item.keywords.join('%20')
    );
  }

  downloadPack(data, props) {
    gtag('event', 'Pack Download', {
      event_category: 'Download',
      event_label: data.item.name,
    });

    let url =
      'https:' +
      subCategoryStore.getState().symbologyJson.meta.s3_root_url +
      data.item.path +
      data.item.name +
      '.zip';
    window.open(url);
  }

  render() {
    let symbology = subCategoryStore.getState().symbologyJson;
    let props = this.props.props;
    let count = 0;

    let divStyle = {
      backgroundColor: '#fadfad',
    };

    let iconButtonElement = () => {
      return (
        <IconButton tooltip='Options'>
          <div className='download-button'></div>
        </IconButton>
      );
    };

    let iconItem = (icon) => {
      //console.log(symbology)
      return (
        <img
          onClick={this.itemSelect.bind(this, '#/single', icon)}
          className='card-image-icon'
          src={'https:' + symbology.meta.s3_root_url + icon.path}
        />
      );
    };

    let cardToolbar = () => {
      return (
        <Toolbar className='card-item'>
          <Typography
            className='card-title'
            onClick={this.updateFilteredPacks.bind(
              this,
              '#/subcat',
              props.index
            )}
          >
            {props.item.name.replace(/_/g, ' ')}
          </Typography>
          <Tooltip title='Download Pack'>
            <IconButton onClick={this.downloadPack.bind(this, props)}>
              <div className='download-button'></div>
            </IconButton>
          </Tooltip>
          {/* <ToolbarGroup className='card-title-container' key={0} float='left'>
            <ToolbarTitle
              
              className='card-title pointer'
              text=
            />
          </ToolbarGroup>

          <ToolbarGroup key={1} float='right'>
            <Menu iconButtonElement={iconButtonElement()}>
              <MenuItem
                className='pointer'
                onClick={this.updateFilteredPacks.bind(
                  this,
                  '#/subcat',
                  props.index
                )}
                primaryText='View Details'
              />
              <MenuItem
                onClick={this.downloadPack.bind(this, props)}
                primaryText='Download Pack'
              />
            </Menu>
          </ToolbarGroup> */}
        </Toolbar>
      );
    };

    return (
      <Paper className='card flex-item' style={divStyle} zDepth={2}>
        {cardToolbar()}

        {props.item.subpacks.map(function (subpack, index) {
          return subpack.icons.map(function (icon, index) {
            if (count < 12) {
              count++;
              return iconItem(icon);
            }
          });
        })}
      </Paper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/icon-card/iconCard.js